import router from '@/router'
import { useFactureStore } from './useFactureStore'
import { navigateTo } from '@/router/navigateTo'

export function useFactureRoutingService() {
  const store = useFactureStore()

  async function loadStoreWithKey(key: any): Promise<boolean> {
    try {
      await store.loadData(key)
      return true
    } catch {
      return false
    }
  }

  function navigateToWithKey(key: any) {
    // const appState = useAppStateStore()
    // const context = TypesContextesAutorisesEnum[appState.contextCourant]
    /// router.push(`/${context}/facture/${key}`)

    return navigateTo({
      to: 'detail',
      domaine: 'factures',
      code: key
    })
  }

  function navigateToDRWithKey(key: any) {
    return navigateTo({
      to: 'detail',
      domaine: 'dr',
      module: 'dossier',
      code: key
    })
  }

  function navigateToDossierWithKey(key: any) {
    // const appState = useAppStateStore()
    // const context = TypesContextesAutorisesEnum[appState.contextCourant]
    // router.push(`/${context}/dossier/${key}`)
    return navigateTo({
      to: 'detail',
      domaine: 'formations',
      module: 'dossier',
      code: key
    })
  }

  function navigateToRechercheFacturesList() {
    const backPath = window.history.state.back as string | undefined
    const isBackToRecherche = backPath && /\/factures(\?|$)/.test(backPath)

    if (isBackToRecherche) {
      router.go(-1)
    } else {
      return navigateTo({
        to: 'recherche',
        domaine: 'factures'
      })
    }
  }

  return { loadStoreWithKey, navigateToWithKey, navigateToDossierWithKey, navigateToDRWithKey, navigateToRechercheFacturesList }
}

